














































import Vue from "vue";
import { onTouchOutsideOnce, onKey } from "@/utils/dom";
export default Vue.extend({
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      isOpen: false,
      onTouchOutsidePopup: null as any
    };
  },
  beforeDestroy() {
    close();
  },
  methods: {
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.isOpen = true;
        this.onTouchOutsidePopup = onTouchOutsideOnce(() => {
          this.isOpen = false;
        }, true)(
          () => document.querySelector(".dropdown-box") as HTMLElement,
          () => [document.querySelector(".dd-selectd-item") as HTMLElement]
        );
      }
    },
    close() {
      this.isOpen = false;
      this.onTouchOutsidePopup && this.onTouchOutsidePopup();
    },
    onSelectd(item: any) {
      this.$emit("onSelect", item);
      this.isOpen = false;
    }
  },
  computed: {
    selctedItem(): string {
      if (this.items.length === 0) {
        return "";
      }
      const selected: any = this.items.find((item: any) => item.selected);
      return selected ? selected.name : (this.items[0] as any).name;
    }
  }
});
